var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"loading":false,"err":_vm.err,"layoutClass":"add-application"}},[_c('h3',[_vm._v("Add a Job Application")]),_vm._v(" "),_c('p',{staticClass:"pb-4"},[_vm._v("Please add the details to manually add a job application to the system.")]),_vm._v(" "),_c('apply-hr',{on:{"submit":_vm.submit}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6abad004","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/job-applications/AddApplication.vue
// module id = bhz4
// module chunks = 64